import { BaseMover } from "./BaseMover.js";
export async function loadBaseMover(engine, refresh = true) {
    await engine.addMover("base", () => new BaseMover(), refresh);
}
